import * as Yup from 'yup';
import {teamMemberPhoto} from '../../../../../../assets/symbols/images/teamMemberPhoto';
import {TLecturer} from '../../../../../../redux/timetable/timetable.type';
import {MAX_LINK_LENGTH, SUMMARY_MAX, summaryMaxRule} from '../../constants';

export type TabId = 'lecturer' | 'about';

export interface Values {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    country: string;
    image: string;
    about: string;
    link: string;
    liveLink: string;
}

export const valuesFromLecturer = (lecturer?: TLecturer): Values => ({
    firstName: lecturer?.firstName ?? '',
    lastName: lecturer?.lastName ?? '',
    email: lecturer?.email ?? '',
    phone: lecturer?.phone ?? '',
    country: '',
    image: lecturer?.image || teamMemberPhoto,
    about: lecturer?.about ?? '',
    link: lecturer?.link ?? '',
    liveLink: lecturer?.liveLink ?? '',
});

export const initialValues: Values = valuesFromLecturer();

export const inputDefaults = {events: {}, className: '', forwardRef: null} as const;

export const buildSchema = (
    firstNameRequiredMessage: string,
    lastNameRequiredMessage: string,
    nameTooShortMessage: string,
    nameTooLongMessage: string,
    phoneInvalidMessage: string,
    phoneTooShortMessage: string,
    phoneTooLongMessage: string,
    invalidLinkMessage: string,
    linkTooLongMessage: string,
    aboutTooLongMessage: string,
) =>
    Yup.object({
        about: summaryMaxRule(SUMMARY_MAX, aboutTooLongMessage),
        firstName: Yup.string()
            .trim()
            .min(2, nameTooShortMessage)
            .max(20, nameTooLongMessage)
            .required(firstNameRequiredMessage),
        lastName: Yup.string()
            .trim()
            .min(2, nameTooShortMessage)
            .max(20, nameTooLongMessage)
            .required(lastNameRequiredMessage),
        email: Yup.string().trim().email(),
        phone: Yup.string()
            .trim()
            .matches(/^\d+$/, {message: phoneInvalidMessage, excludeEmptyString: true})
            .min(7, phoneTooShortMessage)
            .max(15, phoneTooLongMessage),
        link: Yup.string().trim().url(invalidLinkMessage).max(MAX_LINK_LENGTH, linkTooLongMessage),
        liveLink: Yup.string().trim().url(invalidLinkMessage).max(MAX_LINK_LENGTH, linkTooLongMessage),
    });
